export enum InitialValuesTypesEnum {
	default = '',
	all = 'all',
	code = 'codes',
	description = 'descriptions',
}
